import axios from "../../../axios";

export const getOfferList = (payload?: any) => {
  const response = axios.post(`orders/discounts/`, payload);
  return response;
};

export const getOfferData = (id: any) => {
  const response = axios.get(`orders/discounts/${id}/`);
  return response;
};
